import { rootRoute } from "@/routing/routes";
import { createRoute } from "@tanstack/react-router";
import { GeneralTermsPage } from ".";

const index = createRoute({
  path: "general-terms",
  getParentRoute: () => rootRoute,
  component: GeneralTermsPage,
});

export const generalTermsRoutes = index;
